import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import './Tooltip.scss';

class Tooltip extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    position: PropTypes.string,
    text: PropTypes.string,
    justText: PropTypes.string,
    mode: PropTypes.string
  };

  static defaultProps = {
    position: 'right'
  };

  state = {
    show: false
  };

  toggleTooltip = (show) => this.setState({ show });

  render() {
    const { show } = this.state;
    const { position, text, justText, className, mode } = this.props;

    const tooltipClassName = classNames(
      'tooltip',
      `tooltip--${position}`,
      { 'tooltip--show': show },
      className
    );

    return (
      <div className="tooltip__wrapper">
        <div className={tooltipClassName}>
          <div
            className={classNames('tooltip__inner', { '--white': mode || '' })}
          >
            {justText ? <span>{justText}</span> : text && <I18n label={text} />}
          </div>

          <div
            className={classNames('tooltip__arrow', { '--white': mode || '' })}
          />
        </div>
        <div
          className="tooltip__content__wrapper"
          onMouseOut={this.toggleTooltip.bind(this, false)}
          onMouseOver={this.toggleTooltip.bind(this, true)}
          onClick={this.toggleTooltip.bind(this, !show)}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Tooltip;
